import React from 'react';

/**
 * PC 딜 신고하기(제안하기)
 */
function DealReport() {
  const handleClickReport = e => {
    e.preventDefault();

    const suggestUrl = TMON.htLocal.htURL.suggest;
    const dealSrl = TMON.htStaticData.htDealInfo.dealNo;
    const suggestUrlWithDealSrl = `${suggestUrl}?dealSrl=${dealSrl}`;

    if (!TMON.bLogin) {
      TMON.oApp.oUtil.login(suggestUrlWithDealSrl);
      return;
    }
    window.open(suggestUrlWithDealSrl, '_blank');
  };

  return (
    <div className="deal_report">
      <a
        onClick={handleClickReport}
        className="button_report"
        aria-label="딜 신고하기"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="text">신고</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="22"
          height="20"
          viewBox="0 0 22 20"
        >
          <defs>
            <path
              id="prefix__a"
              d="M6.994.944h3.345c2.485 0 4.592 1.824 4.949 4.283l1.379 9.513h-16l1.379-9.513C2.402 2.768 4.51.944 6.994.944z"
            />
          </defs>
          <g fill="none" fillRule="evenodd" transform="translate(-.556 -.111)">
            <rect
              width="21.667"
              height="1.1"
              x=".722"
              y="18.111"
              fill="#7D7E80"
              rx=".55"
            />
            <g transform="translate(2.889 4.333)">
              <mask id="prefix__b" fill="#fff">
                <use xlinkHref="#prefix__a" />
              </mask>
              <path
                stroke="#7D7E80"
                d="M1.244 14.24H16.09L14.793 5.3c-.321-2.213-2.218-3.855-4.454-3.855H6.994c-2.236 0-4.133 1.642-4.453 3.855L1.244 14.24z"
              />
              <path
                stroke="#7D7E80"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.687 3.778c-1.464 0-2.712 1.063-2.944 2.51l-.076.478h0"
                mask="url(#prefix__b)"
              />
            </g>
            <g fill="#7D7E80" transform="translate(2.444)">
              <rect width="1.2" height="3" x="8.389" y=".111" rx=".6" />
              <path d="M.65 2.55c.235-.234.615-.234.849 0l1.273 1.273c.234.235.234.614 0 .849-.235.234-.614.234-.849 0L.65 3.399c-.234-.234-.234-.614 0-.849zM18.016 2.55c-.234-.234-.614-.234-.848 0l-1.273 1.273c-.234.235-.234.614 0 .849.234.234.614.234.848 0l1.273-1.273c.235-.234.235-.614 0-.849z" />
            </g>
          </g>
        </svg>
      </a>
    </div>
  );
}

export default DealReport;